import { takeEvery } from 'redux-saga'
import { call, put, select } from 'redux-saga/effects'

import * as actions from '../actions'
import * as constants from '../constants'
import { getCustomFieldLabel } from '../selectors'

import cleanCustomFieldLabel from './cleanCustomFieldLabel'
import sortByPosition from 'modules/sortByPosition'

import PipelineDeals from 'PipelineDeals'
import fetcher from 'modules/fetcher'
const pd = new PipelineDeals({}, '/api/v3')

const SORT_ENDPOINTS = {
  DealCustomFieldLabel: 'deal_custom_field_labels',
  PersonCustomFieldLabel: 'person_custom_field_labels',
  CompanyCustomFieldLabel: 'company_custom_field_labels',
  ProjectCustomFieldLabel: 'project_custom_field_labels'
}

export function * newCustomFieldLabelSaga ({ payload }) {
  try {
    const customFieldLabels = yield call([pd, pd.customFieldLabels])
    const response = yield call([customFieldLabels, customFieldLabels.create], cleanCustomFieldLabel(payload))

    if (response.custom_field_label_dropdown_entries) {
      response.custom_field_label_dropdown_entries.sort(sortByPosition)
    }

    yield put(actions.newCustomFieldLabelFormSuccess({ label: response }))
  } catch (exception) {
    console.error(exception)

    const json = yield call([exception.response, exception.response.json])
    yield put(actions.newCustomFieldLabelFormFailure({ _error: json }))
  }
}

export function * watchNewCustomFieldLabelSaga () {
  yield call(takeEvery, constants.NEW_CUSTOM_FIELD_LABEL_FORM_SUBMIT, newCustomFieldLabelSaga)
}

export function * editCustomFieldLabelSaga ({ payload }) {
  try {
    const customFieldLabels = yield call([pd, pd.customFieldLabels])
    const response = yield call([customFieldLabels, customFieldLabels.update], cleanCustomFieldLabel(payload))

    if (response.custom_field_label_dropdown_entries) {
      response.custom_field_label_dropdown_entries.sort(sortByPosition)
    }

    const current = yield select(getCustomFieldLabel, { id: payload.id })

    yield put(actions.editCustomFieldLabelFormSuccess({ label: response, previous: current }))
  } catch (exception) {
    console.error(exception)

    const json = yield call([exception.response, exception.response.json])
    yield put(actions.editCustomFieldLabelFormFailure({ _error: json }))
  }
}

export function * watchEditCustomFieldLabelSaga () {
  yield call(takeEvery, constants.EDIT_CUSTOM_FIELD_LABEL_FORM_SUBMIT, editCustomFieldLabelSaga)
}

export function * deleteCustomFieldLabelSaga ({ id }) {
  try {
    const label = yield select(getCustomFieldLabel, { id })

    const customFieldLabels = yield call([pd, pd.customFieldLabels])
    yield call([customFieldLabels, customFieldLabels.delete], id)

    yield put(actions.deleteCustomFieldLabelSuccess(label))
  } catch (exception) {
    console.error(exception)

    yield put(actions.deleteCustomFieldLabelFailure({ _error: exception.message }))
  }
}

export function * watchDeleteCustomFieldLabelSaga () {
  yield call(takeEvery, constants.DELETE_CUSTOM_FIELD_LABEL, deleteCustomFieldLabelSaga)
}

export function * watchMoveCustomFieldLabelCustomFieldGroupSaga () {
  yield call(
    takeEvery,
    constants.MOVE_CUSTOM_FIELD_LABEL_CUSTOM_FIELD_GROUP,
    updateCustomFieldLabelSaga
  )
}

export function * repositionCustomFieldLabelSaga ({ payload: { label, originalPosition } }) {
  try {
    const customFieldLabels = yield call([pd, pd.customFieldLabels])
    const response = yield call([customFieldLabels, customFieldLabels.update], label)

    yield put(actions.repositionCustomFieldLabelSuccess({ label: response, originalPosition }))
  } catch (exception) {
    console.error(exception)

    yield put(actions.repositionCustomFieldLabelFailure({ _error: exception.message }))
  }
}

export function * watchRepositionCustomFieldLabelSaga () {
  yield call(takeEvery, constants.REPOSITION_CUSTOM_FIELD_LABEL, repositionCustomFieldLabelSaga)
}

export function * sortCustomFieldLabelsSaga ({ payload: { order, type, groupId } }) {
  const endpoint = SORT_ENDPOINTS[type]
  if (!endpoint) return

  const body = { order, custom_field_group_id: groupId || null }

  try {
    yield call(
      fetcher,
      `/api/v3/admin/${endpoint}/sort`,
      {
        method: 'PUT',
        body: JSON.stringify(body)
      }
    )
    yield put(actions.sortCustomFieldLabelsSuccess({ order }))
  } catch (exception) {
    console.error(exception)
    yield put(actions.sortCustomFieldLabelsFailure({ _error: exception.message }))
    yield put(actions.fetchCustomFields())
  }
}

export function * watchSortCustomFieldLabelsSaga () {
  yield call(takeEvery, constants.SORT_CUSTOM_FIELD_LABELS, sortCustomFieldLabelsSaga)
}

export function * updateCustomFieldLabelSaga ({ payload }) {
  try {
    const customFieldLabels = yield call([pd, pd.customFieldLabels])
    const response = yield call([customFieldLabels, customFieldLabels.update], cleanCustomFieldLabel(payload))

    if (response.custom_field_label_dropdown_entries) {
      response.custom_field_label_dropdown_entries.sort(sortByPosition)
    }

    const current = yield select(getCustomFieldLabel, { id: payload.id })

    yield put(actions.updateCustomFieldLabelSuccess({ label: response, previous: current }))
  } catch (exception) {
    console.error(exception)

    yield put(actions.updateCustomFieldLabelFailure({ _error: exception.message }))
  }
}

export function * watchUpdateCustomFieldLabelSaga () {
  yield call(takeEvery, constants.UPDATE_CUSTOM_FIELD_LABEL, updateCustomFieldLabelSaga)
}
